module.exports = __webpack_public_path__ + "img/level_c_gray.936692ab.png";